import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id AFF2782E-A558-40EF-9B8C-787BAE055D57
 * name glass-pint-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/glass-pint-outline.svg
 * tags
 * - Food / Drink 
 */
export const GlassPintOutlineIcon = createSvgIcon(<><path d="M4 2L6 22H17L19 2H4M6.2 4H16.8L15.2 20H7.8L6.2 4Z" /></>, 'GlassPintOutlineIcon');
export default GlassPintOutlineIcon